import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ChangePassword = () => {
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  
  const { currentUser, changePassword } = useAuth();
  const navigate = useNavigate();

  // Reindirizza alla dashboard se l'utente non è al primo accesso
  useEffect(() => {
    if (currentUser && !currentUser.first_login) {
      navigate('/dashboard');
    }
  }, [currentUser, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validazione
    if (newPassword !== confirmPassword) {
      return setError('Le password non corrispondono');
    }
    
    if (newPassword.length < 8) {
      return setError('La password deve essere di almeno 8 caratteri');
    }
    
    setError('');
    setLoading(true);
    
    try {
      const result = await changePassword(oldPassword, newPassword);
      
      if (result.success) {
        // Reindirizza alla dashboard dopo il cambio password
        navigate('/dashboard');
      } else {
        setError(result.error);
      }
    } catch (err) {
      setError('Si è verificato un errore durante il cambio password');
      console.error(err);
    }
    
    setLoading(false);
  };

  return (
    <div className="mx-auto mt-8 w-full max-w-md">
      <div className="card">
        <div className="card-body">
          <div className="flex items-center justify-between gap-3">
            <div>
              <h1 className="text-xl font-bold text-slate-900">Cambio Password</h1>
              <p className="mt-1 text-sm text-slate-600">
                Questo è il tuo primo accesso. Per motivi di sicurezza, è necessario cambiare la password temporanea.
              </p>
            </div>
            <img src="/Logo.png" alt="Logo" className="h-11 w-11 rounded-xl" />
          </div>

          {error ? <div className="alert-error mt-4">{error}</div> : null}

          <form onSubmit={handleSubmit} className="mt-5 space-y-4">
            <div>
              <label htmlFor="oldPassword" className="label">
                Password Temporanea
              </label>
              <input
                id="oldPassword"
                name="oldPassword"
                type="password"
                required
                value={oldPassword}
                onChange={(e) => setOldPassword(e.target.value)}
                className="input mt-1"
              />
            </div>

            <div>
              <label htmlFor="newPassword" className="label">
                Nuova Password
              </label>
              <input
                id="newPassword"
                name="newPassword"
                type="password"
                required
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                className="input mt-1"
              />
              <div className="helper mt-1">Minimo 8 caratteri.</div>
            </div>

            <div>
              <label htmlFor="confirmPassword" className="label">
                Conferma Nuova Password
              </label>
              <input
                id="confirmPassword"
                name="confirmPassword"
                type="password"
                required
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                className="input mt-1"
              />
            </div>

            <button type="submit" className="btn-primary w-full" disabled={loading}>
              {loading ? 'Cambio in corso...' : 'Cambia Password'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
